<template>
    <div class="flex-row-with-gap">
        {{ props.statusDate.status }} - {{ props.statusDate.date }}
        <div class="flex-row-with-gap">
            <primevue-select
                v-model="statusToAdd"
                filter
                :options="dataValidationStore.statuses"
                placeholder="Select a status"
            />
            <basic-date-picker v-model="dateForStatusToAdd" />
            <p-button
                label="Change status"
                @click="submit"
                :disabled="!statusToAdd || !dateForStatusToAdd"
            />
        </div>
        <p-button
            label="Delete"
            class="p-button-danger"
            @click="emit('delete')"
        />
    </div>
</template>

<script setup lang="ts">
import { UseDataValidationStore } from '@/stores/storageTracking/DataValidationStore.ts';
import { IStatusDate } from '@/interfaces/storageTracking/IArticle.ts';
import PrimevueSelect from 'primevue/select';
import PButton from 'primevue/button';
import BasicDatePicker from '@/components/powerMarkets/common/BasicDatePicker.vue';
import { ref } from 'vue';

const dataValidationStore = UseDataValidationStore();

const props = defineProps<{
    statusDate: IStatusDate;
}>();

const emit = defineEmits<{(e: 'change-status', value: IStatusDate): void;
    (e: 'delete'): void;
}>();

const statusToAdd = ref(null);
const dateForStatusToAdd = ref<Date | null>(null);

function submit (): void {
    if (!statusToAdd.value || !dateForStatusToAdd.value) return;
    const dateAsString = new Intl.DateTimeFormat('en-GB').format(dateForStatusToAdd.value);

    emit('change-status', {
        status: statusToAdd.value,
        date: dateAsString,
    });
    statusToAdd.value = null;
    dateForStatusToAdd.value = null;
}
</script>
